function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { fetchSales, titleCase } from "./territory-common";

/*
 * Shared bits for the rep pages (Territory & Reps redesign 2026-10-09, boards 3, 6, 7):
 * rep-detail.jsx, rep-dealer-products.jsx, rep-compare.jsx. Styles: sass/v2/_territory-rep.scss (trr-).
 */

const n0 = v => Number(v) || 0;

/** $32.4M / $389K / $12.5K / $812 */
export function moneyShort(v) {
  const n = n0(v);
  if (!n) return "$0";
  const a = Math.abs(n);
  const s = n < 0 ? "-$" : "$";
  const one = x => x.toFixed(1).replace(/\.0$/, "");
  if (a >= 1e9) return s + one(a / 1e9) + "B";
  if (a >= 1e6) return s + one(a / 1e6) + "M";
  if (a >= 1e4) return s + Math.round(a / 1e3) + "K";
  if (a >= 1e3) return s + one(a / 1e3) + "K";
  return s + Math.round(a);
}
const MON = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
/** "2026-10-02" → "Oct 2" (this year) or "Oct 2, 2025". Empty → "". */
export function dateShort(v) {
  const m = String(v || "").match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return "";
  const y = +m[1];
  const s = `${MON[+m[2] - 1]} ${+m[3]}`;
  return y === new Date().getFullYear() ? s : `${s}, ${y}`;
}

/** Display name for a rep or dealer: ALL-CAPS feed names get title-cased. */
export function nameOf(v, fallback) {
  const s = String(v == null ? "" : v).trim();
  if (!s) return fallback || "";
  return /[A-Z]/.test(s) && s === s.toUpperCase() ? titleCase(s) : s;
}
export const place = (city, region) => [city ? nameOf(city) : "", region ? String(region).toUpperCase() : ""].filter(Boolean).join(", ");

/** Roster lookup for a rep's name (and the other reps for the compare picker). Never throws. */
export async function loadRoster(range) {
  try {
    const rows = await fetchSales(`/sales/reps/${range}`);
    return Array.isArray(rows) ? rows : [];
  } catch (e) {
    return [];
  }
}
export function findRep(roster, code) {
  const norm = v => String(v || "").trim().toLowerCase();
  return (roster || []).find(r => norm(r.repCode) === norm(code)) || null;
}

/** Copy text to the clipboard; resolves true when it worked. */
export async function copyText(text) {
  try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch (e) {/* fall through to the textarea route */}
  try {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  } catch (e) {
    return false;
  }
}

/** Product thumbnail with a quiet placeholder when there is no image (or it fails to load). */
export class Thumb extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      broken: false
    });
  }
  componentDidUpdate(prev) {
    if (prev.src !== this.props.src && this.state.broken) this.setState({
      broken: false
    });
  }
  render() {
    const {
      src
    } = this.props;
    if (!src || this.state.broken) return /*#__PURE__*/React.createElement("span", {
      className: "trr-thumb empty",
      "aria-hidden": "true"
    }, /*#__PURE__*/React.createElement("i", {
      className: "material-icons"
    }, "image"));
    return /*#__PURE__*/React.createElement("span", {
      className: "trr-thumb"
    }, /*#__PURE__*/React.createElement("img", {
      src: src,
      alt: "",
      loading: "lazy",
      onError: () => this.setState({
        broken: true
      })
    }));
  }
}

/** Composer-style top bar for the rep sub-pages: back, crumbs + title + meta, controls on the right. */
export function RepSubTop({
  crumbs,
  title,
  meta,
  onBack,
  backLabel,
  children
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "ecc-top trr-top"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "ecc-back",
    "aria-label": backLabel || "Back to the rep",
    onClick: onBack
  }, /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 3L5 8l5 5",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "ecc-titleblock trr-titleblock"
  }, crumbs ? /*#__PURE__*/React.createElement("span", {
    className: "trr-crumbs"
  }, crumbs) : null, /*#__PURE__*/React.createElement("h1", {
    className: "trr-title"
  }, title), meta ? /*#__PURE__*/React.createElement("span", {
    className: "ecc-meta trr-meta"
  }, meta) : null), /*#__PURE__*/React.createElement("span", {
    className: "ecc-spacer"
  }), children ? /*#__PURE__*/React.createElement("div", {
    className: "trr-controls"
  }, children) : null);
}

/** Calm placeholder for a rail that has not landed yet. */
export const NotYet = ({
  children
}) => /*#__PURE__*/React.createElement("div", {
  className: "trr-notyet"
}, children);